import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import "./global.css";

// Import ElevenLabs TTS Service (loads globally)
import "./services/ElevenLabsTTSService";

// Enable ElevenLabs TTS automatically
setTimeout(() => {
    if (window.elevenLabsTTS) {
        // Enable ElevenLabs TTS (with browser TTS fallback)
        window.elevenLabsTTS.setEnabled(true);
        window.elevenLabsTTS.setVoice('bella'); // Bella has a warm, soft American voice
        console.log('🎤 ElevenLabs TTS enabled with Bella voice (warm, soft American)');
        console.log('🎤 Will fallback to browser TTS if ElevenLabs fails');
    }
}, 100);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <HashRouter>
        <App />
    </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
